import React from "react"
import DropdownProjectFilter from "../../../../../components/compounds/DropdownProjectFilter.compound"
import { KEYBOARD_ACTIONS } from "../../../../../consts/keyBoard.consts"
import ClientProjectChip from "../../../../../components/molecules/ClientProjectChip.molecule"
import InputPlaceholderChipTemplate from "../../../../../components/molecules/InputPlaceholderChipTemplate.molecule"

function ProjectsChipDropdown({
  value,
  dropdownProjectFilterRef,
  categoryDropdownRef,
  validations,
  setValidations,
  handleSubmit,
  checkAllFields,
  fieldsDoesNotHaveErrors,
  activeProjects,
  setSelectedProject,
  validateFieldValue,
  highlighted,
  loading,
}) {
  const activeProject = activeProjects.find(
    (option) => option.projectID === value
  )
  return (
    <div className={`dropdown-project-chip-selector-wrapper`}>
      <DropdownProjectFilter
        ref={dropdownProjectFilterRef}
        value={value}
        onChange={(e) => {
          setSelectedProject(e)
          setValidations(validateFieldValue(validations, "projectId", e.value))
        }}
        resetFilterOnHide={true}
        loading={loading}
        options={activeProjects}
        error={validations.projectId.errors?.length}
        inputProps={(inputProps) => ({
          autoFocus: true,
          className: "w-full",
          onKeyDown: (e) => {
            if (e.key === KEYBOARD_ACTIONS.ENTER) {
              checkAllFields(validations, setValidations)
              if (fieldsDoesNotHaveErrors(validations)) {
                handleSubmit()
                return
              }
            }

            if (
              e.key === KEYBOARD_ACTIONS.ENTER ||
              e.key === KEYBOARD_ACTIONS.TAB
            ) {
              if (e.key === KEYBOARD_ACTIONS.TAB) {
                dropdownProjectFilterRef.current.hide()
                e.preventDefault()
              }
              if (value) {
                categoryDropdownRef.current?.show()
              }
            }

            // Let the original Dropdown keyboard handler process arrow keys
            inputProps.filterInputKeyDown(e)
          },
        })}
      />
      {value && activeProject ?
        <ClientProjectChip
          clientCode={activeProject.clientTagName}
          projectCode={activeProject.projectTagName}
          onClick={() => {
            dropdownProjectFilterRef.current?.show()
          }}
        />
      : <InputPlaceholderChipTemplate
          highlighted={highlighted}
          error={validations.projectId.errors?.length}
          template={
            <span className="p-chip-text text-overflow-ellipsis white-space-nowrap overflow-hidden max-w-12rem flex gap-1 align-items-center">
              Elige un proyecto
              {validations.projectId.errors?.length ?
                <i
                  className="pi pi-exclamation-triangle"
                  data-pr-tooltip="Este es un campo requerido"
                  data-pr-position="bottom"
                />
              : null}
            </span>
          }
          onClick={() => {
            dropdownProjectFilterRef.current?.show()
          }}
        />
      }
    </div>
  )
}

export default ProjectsChipDropdown
